export default __webpack_public_path__ + "static/media/tunisia.3796635e.svg";